module.exports = __webpack_public_path__ + "static/media/report_blue.db5c828d.svg";